import * as React from 'react';
import classnames from 'classnames';
import { useIntl } from '@grandvisionhq/state';
import Price from '../Price/Price.js';

const PriceTag = ({ originalPrice , originalCentAmount =true , discountedPrice , discountedCentAmount =true , currency ='EUR' , className ,  })=>{
    const { getLabel  } = useIntl();
    const showDiscount = typeof discountedPrice !== 'undefined';
    return /*#__PURE__*/ React.createElement("span", {
        className: classnames('price-tag', className)
    }, discountedPrice !== originalPrice && /*#__PURE__*/ React.createElement(Price, {
        "aria-label": showDiscount ? getLabel('common.originalPrice') : undefined,
        value: originalPrice,
        centAmount: originalCentAmount,
        currency: currency,
        type: showDiscount ? 'strikethrough' : 'default',
        className: "price-tag__price"
    }), showDiscount && /*#__PURE__*/ React.createElement(Price, {
        "aria-label": getLabel('common.discountedPrice'),
        value: discountedPrice,
        centAmount: discountedCentAmount,
        currency: currency,
        type: "discount",
        className: "price-tag__price"
    }));
};
var PriceTag$1 = PriceTag;

export { PriceTag$1 as default };
//# sourceMappingURL=PriceTag.js.map
